import classNames from 'classnames';
import { IScoreNumberProps, ScoreNumber } from './ScoreNumber';
import { IScoreLink, ScoreLink } from './ScoreLink';
import lm from './score.module.less';

export interface IScoreProps extends Omit<IScoreNumberProps, 'className'>, IScoreLink {
  className?: string;
}

export const Score = (props: IScoreProps) => {

  return <div className={classNames(props.className, lm.w)}>
    <ScoreNumber {...props} className={lm.num}></ScoreNumber>
    <ScoreLink {...props} className={lm.link} />
  </div>;

};
